import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';

export type TwoLineCellParams = {
  title?: string;
  subtitle?: string;
  infoTooltipKey?: string;
};

@Component({
  selector: 'app-two-line-cell-renderer',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './two-line-cell-renderer.component.html',
  styleUrl: './two-line-cell-renderer.component.scss',
})
export class TwoLineCellRendererComponent implements ICellRendererAngularComp {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() infoTooltipKey?: string | null = null;

  agInit(params: ICellRendererParams & TwoLineCellParams): void {
    this.title = params.title ?? String(params.value ?? '');
    this.subtitle = params.subtitle ?? '';
    this.infoTooltipKey = params.infoTooltipKey;
  }

  refresh(): boolean {
    return false;
  }
}
